module.exports = __webpack_public_path__ + "static/img/qml-pay-1@2x.0ffda26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/qml/pay/img/qml-pay-1@2x.png
// module id = 18f0
// module chunks = 1